
import * as React from 'react';
import { Welcome } from './Welcome/Welcome';
import { Description } from './Description/Description';
import { Benefits } from './Benefits/Benefits';
import { Feed } from './Feed/Feed';
import './Index.css';

function Index(props) {


    return(
        <React.Fragment>
            {
            !
                props.logged 
            ? 
                <React.Fragment> 
                    <Welcome url={props.url}/>
                    <Description />
                    <Benefits />
                </React.Fragment>
            : 
                <Feed
                    logged={props.logged}
                    typeUser={props.typeUser}
                    username={props.username}
                    url={props.url}
                /> 
            }
        </React.Fragment>
    )
}

export { Index }